import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import Card from "react-bootstrap/Card";

const PrintQaulityCertificateLabel = (props) => {
  const formRef = useRef(null);
  const [formVal, setFormVal] = useState("");
  const [printLabelModel, setPrintLabelModel] = useState(false);
  const [cardsLabels, setCardsLabels] = useState(false);
  const { t } = useTranslation();

  const generateCards = () => {
    const quantityPerJobCard = props?.row?.quantityPerJobCard;
    const stdLabelSize = process.env.REACT_APP_STDLABELSIZE;
    const fullCards = Math.floor(quantityPerJobCard / stdLabelSize);
    const remainder = quantityPerJobCard % stdLabelSize;

    let dynamicCards = [];

    for (let i = 0; i < fullCards; i++) {
      dynamicCards.push({ ...props?.row, qty: stdLabelSize });
    }

    if (remainder > 0) {
      dynamicCards.push({ ...props?.row, qty: remainder });
    }

    setCardsLabels(dynamicCards);
  };

  const printLabel = () => {
    finalPrint(formVal, props);
  };

  const finalPrint = () => {
    const source = document.getElementById("printable-area");
    if (!source) return;

    const cards = Array.from(source.querySelectorAll(".printQCLabel"));
    if (!cards.length) return;

    // Preserve the original two-column print layout.
    const pages = [];
    for (let i = 0; i < cards.length; i += 4) {
      const row = cards.slice(i, i + 4).map((card) => card.outerHTML);
      pages.push(`<div class="card-grid">${row.join("")}</div>`);
    }

    const printWindow = window.open("", "", "height=800,width=800");
    if (!printWindow) return;

    printWindow.document.open();
    printWindow.document.write(`
    <html>
      <head>
        <title>Print</title>
        <style>
          @media print {
  @page { size: 4in auto; margin: 0; }

  html, body {
    width: 4in;
    margin: 0 !important;
    padding: 0 !important;
  }

  /* kill any unexpected default spacing */
  * {
    margin: 0 !important;
    padding: 0 !important;
  }

  .card-grid {
    width: 4in;
    display: grid !important;
    grid-template-columns: 2in 2in;
    grid-template-rows: 100px 100px;

    /* 🔥 this removes the “top gap” effect */
    place-content: start !important;
    place-items: stretch !important;

    row-gap: 0 !important;
    column-gap: 0 !important;
  }

  .printQCLabel {
    width: 2in !important;
    height: 2in !important;

    box-sizing: border-box;
    padding: 12px !important;

    border: none !important;
    outline: none !important;
    box-shadow: none !important;

    display: flex !important;
    flex-direction: column;
    justify-content: flex-start !important;  /* push content up */
    align-items: center;
    text-align: center;

    overflow: hidden;
    white-space: normal;
    word-break: break-word;

    font-family: Arial, Helvetica, sans-serif !important;
  }

  .printQCLabel .card-body { padding: 0 !important; }

  .printQCLabel .card-title {
    font-size: 10px !important;
    font-weight: 900 !important;
    margin-bottom: 3px !important;
    line-height: 1.15 !important;
  }

  .printQCLabel .card-subtitle {
    font-size: 9px !important;
    font-weight: 700 !important;
    margin: 1px 0 !important;
    line-height: 1.15 !important;
  }

  .printQCLabel .label-size-name {
    font-size: 8px !important;
  }
}

        </style>
      </head>
      <body>
        ${pages.join("")}
      </body>
    </html>
  `);

    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 300);
  };

  return (
    <>
      {!printLabelModel && (
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Print Label
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="qr-code">
            <Form noValidate ref={formRef}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label className="col-form-label">
                  {"Please Enter Remarks"}
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  onChange={(e) => setFormVal(e.target.value)}
                  required
                  autoFocus
                />
                <Form.Control.Feedback type="invalid">
                  {t(
                    "msg_master_list.msg_customer.customer_address_validation"
                  )}
                </Form.Control.Feedback>
              </Form.Group>
            </Form>

            <Button
              type="button"
              variant="success"
              className="btn btn-success float-right"
              onClick={() => {
                setPrintLabelModel(true);
                generateCards();
              }}
            >
              {"CONFIRM"}
            </Button>
          </Modal.Body>
        </Modal>
      )}

      {printLabelModel && (
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Print Label
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="card-grid" id="printable-area">
              {cardsLabels?.map((row, index) => (
                <Card className="printQCLabel" key={index}>
                  <Card.Body>
                    <Card.Title>TELMA MICRO NEEDLES </Card.Title>
                    <Card.Subtitle className="mb-2">
                      {row.sizeCode}
                    </Card.Subtitle>
                    {row.sizeName && (
                      <Card.Subtitle className="mb-2 label-size-name">
                        {row.sizeName}
                      </Card.Subtitle>
                    )}
                    <Card.Subtitle className="mb-2">
                      BC NO : {row.batch}
                    </Card.Subtitle>
                    <Card.Subtitle className="mb-2">
                      QTY : {row.qty} PC
                    </Card.Subtitle>
                    {formVal && (
                      <Card.Subtitle className="mb-2"> {formVal}</Card.Subtitle>
                    )}
                  </Card.Body>
                </Card>
              ))}

              <Card className="printQCLabel">
                <Card.Body>
                  <Card.Title>TELMA MICRO NEEDLES</Card.Title>
                  <Card.Subtitle className="mb-2">
                    {cardsLabels[0]?.sizeCode}
                  </Card.Subtitle>
                  {cardsLabels[0]?.sizeName && (
                    <Card.Subtitle className="mb-2 label-size-name">
                      {cardsLabels[0]?.sizeName}
                    </Card.Subtitle>
                  )}
                  <Card.Subtitle className="mb-2">
                    BC NO : {cardsLabels[0]?.batch}
                  </Card.Subtitle>
                  {/* <Card.Subtitle className="mb-2">CUSTOMER : {props.row.customerName}</Card.Subtitle> */}
                  <Card.Subtitle className="mb-2">
                    Total QTY : {props.row.quantityPerJobCard} PC
                  </Card.Subtitle>
                  {formVal && (
                    <Card.Subtitle className="mb-2"> {formVal}</Card.Subtitle>
                  )}
                </Card.Body>
              </Card>
            </div>

            <br />

            <Button
              type="button"
              variant="primary"
              className="btn btn-primary float-right"
              onClick={() => printLabel()}
            >
              {"PRINT"}
            </Button>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default PrintQaulityCertificateLabel;
